package hk.com.vr360_demo2.webapp.component.marzipano.component

import emotion.react.css
import hk.com.vr360_demo2.webapp.Colors
import hk.com.vr360_demo2.webapp.component.editor_rewrite.component.HotspotAnimatedImage
import hk.com.vr360_demo2.webapp.component.editor_rewrite.component.resolveHotspotIconName
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import web.cssom.AlignItems
import web.cssom.BoxShadow
import web.cssom.Color
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.NamedColor
import web.cssom.Padding
import web.cssom.Position
import web.cssom.WhiteSpace
import web.cssom.ZIndex
import web.cssom.pct
import web.cssom.px
import kotlin.js.unsafeCast

external interface EditorHotspotIconWithTipProps : Props {
    var iconUrl: String?
    var tipText: String?
}

val EditorHotspotIconWithTip = FC<EditorHotspotIconWithTipProps> { props ->
    val iconName = resolveHotspotIconName(props.iconUrl)
    val tipText = props.tipText?.takeIf { it.isNotBlank() } ?: "hotspot"

    div {
        css {
            width = 60.px
            height = 60.px
            position = Position.relative
            display = Display.flex
            alignItems = AlignItems.center
            justifyContent = JustifyContent.center
        }

        HotspotAnimatedImage {
            this.iconName = iconName
            width = 60
            height = 60
            alt = "hotspot"
            fps = 12
            backgroundColor = "transparent"
        }

        div {
            css {
                position = Position.absolute
                left = 50.pct
                bottom = 100.pct
                asDynamic().transform = "translate(-50%, -4px)"
                backgroundColor = Colors.Background.Semitransparent
                color = NamedColor.white
                padding = Padding(4.px, 6.px)
                borderRadius = 6.px
                fontSize = 14.px
                whiteSpace = WhiteSpace.nowrap
                boxShadow = BoxShadow(0.px, 2.px, 8.px, Color("rgba(0,0,0,0.15)"))
                zIndex = 100.unsafeCast<ZIndex>()
                minWidth = 40.px
            }
            +tipText
        }
    }
}
